/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnalyticsDataset,
  AnalyticsDataset$inboundSchema,
} from "./analyticsdataset.js";

export type AnalyticsDescribeResult = {
  datasets: Array<AnalyticsDataset>;
};

/** @internal */
export const AnalyticsDescribeResult$inboundSchema: z.ZodMiniType<
  AnalyticsDescribeResult,
  unknown
> = z.object({
  datasets: z.array(AnalyticsDataset$inboundSchema),
});

export function analyticsDescribeResultFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsDescribeResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsDescribeResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsDescribeResult' from JSON`,
  );
}
